import apiClient from "../utils/apiClient";

export const getMarkup = async (actOrHotel) => {
    try {
        const response = await apiClient.get(`/sys/markup/${actOrHotel}`)	
        return response?.data;
    } catch (e) {
        throw new Error("error connection", e);  
    }
  }


export const validateCupon = async (data) => {
    try {
        const response = await apiClient.post(`/validate/cupon`, data)	
        return response?.data;
    } catch (e) {
        throw new Error("error connection", e);  
    }
  }